export var RUB = '₽';
export var ZERO = '0';
export var DOUBLE_ZERO = '00';
export var COMMA = ',';
export var DOT = '.';
export var MINUS = '-';
export var NBSP = "\xA0";
export var EMPTY_STRING = '';
export var DAYJS_FORMAT_DAY_MONTH = 'DD.MM';
export var ADVERT_LABEL = 'реклама';
export var PRODUCT_TEST_ID = 'PRODUCT_TEST_ID';
export var PRODUCT_IMAGE_TEST_ID = 'PRODUCT_IMAGE_TEST_ID';
export var PRODUCT_NAME_TEST_ID = 'PRODUCT_NAME_TEST_ID';
export var PRODUCT_COMMENT_BUTTON_TEST_ID = 'PRODUCT_COMMENT_BUTTON_TEST_ID';
export var PRODUCT_NOTE_TEST_ID = 'PRODUCT_NOTE_TEST_ID';
export var PRODUCT_ADD_BUTTON_TEST_ID = 'PRODUCT_ADD_BUTTON_TEST_ID';
export var PRODUCT_CHANGE_BUTTON_TEST_ID = 'PRODUCT_CHANGE_BUTTON_TEST_ID';
export var PRODUCT_BACK_IN_CART_BUTTON_TEST_ID = 'PRODUCT_BACK_IN_CART_BUTTON_TEST_ID';
export var PRODUCT_NOT_AVALIBLE_BUTTON_REMOVE_TEST_ID = 'PRODUCT_NOT_AVALIBLE_BUTTON_REMOVE_TEST_ID';
export var PRODUCT_NOT_AVALIBLE_BUTTON_TEST_ID = 'PRODUCT_NOT_AVALIBLE_BUTTON_TEST_ID';
export var PRODUCT_COMMENT_BUTTON_MOBILE_TEST_ID = 'PRODUCT_COMMENT_BUTTON_MOBILE_TEST_ID';
export var FAVORITE_ICON_TEST_ID = 'FAVORITE_ICON_TEST_ID';
export var FAVORITE_AUTH_POPUP_TEST_ID = 'FAVORITE_AUTH_POPUP_TEST_ID';
export var FAVORITE_AUTH_BUTTON_TEST_ID = 'FAVORITE_AUTH_BUTTON_TEST_ID';
export var REMOVE_BUTTON_TEST_ID = 'REMOVE_BUTTON_TEST_ID';
export var PRICE_INTEGER_TEST_ID = 'PRICE_INTEGER_TEST_ID';
export var FAVORITE_BTN_TEST_ID = 'FAVORITE_BTN_TEST_ID';